export const PASSWORD_GUIDANCE = "10자 이상 · 영문+숫자 조합";

export function validatePasswordPolicy(password, label = "비밀번호") {
  const value = String(password || "");

  if (value.length < 10) {
    return `${label}는 10자 이상으로 입력해 주세요.`;
  }

  if (!/[A-Za-z]/.test(value) || !/\d/.test(value)) {
    return `${label}는 영문과 숫자를 모두 포함해 주세요.`;
  }

  return "";
}

export function getWeakPasswordGuidance(label = "비밀번호") {
  return `${label}는 10자 이상 영문과 숫자를 조합하고, 흔한 단어나 연속된 숫자는 피해주세요.`;
}
